import { Component, input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { OnyxTextFieldComponent } from '@onyx/angular';

@Component({
  selector: 'app-points-of-interest-gate-cell',
  imports: [OnyxTextFieldComponent, ReactiveFormsModule],
  templateUrl: './points-of-interest-gate-cell.component.html',
  styleUrl: './points-of-interest-gate-cell.component.scss',
})
export class PointsOfInterestGateCellComponent {
  public readonly gate = input.required<FormControl | null>();
}
